import type { HelpApp } from '~/app/data/apps';

export function sortCategories(categories: string[], app?: HelpApp) {
	const order = app?.categoryOrder || [];
	const weight = (c: string) => {
		const i = order.indexOf(c);
		return i === -1 ? 10_000 + c.charCodeAt(0) : i;
	};
	return [...categories].sort((a, b) => weight(a) - weight(b));
}
